module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Spot SponsorBlock","short_name":"SponsorBlock","start_url":"/","background_color":"#fff","theme_color":"#fff","icon":"static/LogoSponsorBlockSimple256px.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"94b2aaf4d09b4265c6638682cbab5ba7"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
